const ROOT_MARGIN = '400px 0px';

const contactStyles = [
	{
		featureType: 'all',
		elementType: 'labels.text.fill',
		stylers: [{ saturation: 36 }, { color: '#000000' }, { lightness: 40 }],
	},
	{
		featureType: 'all',
		elementType: 'labels.text.stroke',
		stylers: [{ visibility: 'on' }, { color: '#000000' }, { lightness: 16 }],
	},
	{
		featureType: 'all',
		elementType: 'labels.icon',
		stylers: [{ visibility: 'off' }],
	},
	{
		featureType: 'administrative',
		elementType: 'geometry.fill',
		stylers: [{ color: '#000000' }, { lightness: 20 }],
	},
	{
		featureType: 'administrative',
		elementType: 'geometry.stroke',
		stylers: [{ color: '#000000' }, { lightness: 17 }, { weight: 1.2 }],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 20 }],
	},
	{
		featureType: 'poi',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 21 }],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.fill',
		stylers: [{ color: '#000000' }, { lightness: 17 }],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.stroke',
		stylers: [{ color: '#000000' }, { lightness: 29 }, { weight: 0.2 }],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 18 }],
	},
	{
		featureType: 'road.local',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 16 }],
	},
	{
		featureType: 'transit',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 19 }],
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 17 }],
	},
];

const listingStyles = [
	{ featureType: 'all', elementType: 'all', stylers: [{ visibility: 'on' }] },
	{ featureType: 'all', elementType: 'geometry', stylers: [{ visibility: 'on' }] },
	{
		featureType: 'all',
		elementType: 'labels.text.fill',
		stylers: [{ saturation: 36 }, { color: '#000000' }, { lightness: 40 }],
	},
	{
		featureType: 'all',
		elementType: 'labels.text.stroke',
		stylers: [{ visibility: 'on' }, { color: '#000000' }, { lightness: 16 }],
	},
	{ featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
	{
		featureType: 'administrative',
		elementType: 'geometry.stroke',
		stylers: [{ color: '#000000' }, { lightness: 17 }, { weight: 1.2 }],
	},
	{
		featureType: 'administrative.country',
		elementType: 'geometry',
		stylers: [{ color: '#868686' }, { visibility: 'off' }],
	},
	{
		featureType: 'administrative.country',
		elementType: 'geometry.stroke',
		stylers: [{ visibility: 'on' }],
	},
	{
		featureType: 'administrative.country',
		elementType: 'labels.text.fill',
		stylers: [{ color: '#d2d2d2' }],
	},
	{
		featureType: 'administrative.province',
		elementType: 'geometry',
		stylers: [{ color: '#676767' }, { visibility: 'on' }],
	},
	{
		featureType: 'administrative.locality',
		elementType: 'labels.text.fill',
		stylers: [{ color: '#848484' }],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { lightness: 20 }],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry.fill',
		stylers: [{ color: '#212121' }, { visibility: 'on' }],
	},
	{
		featureType: 'landscape.man_made',
		elementType: 'geometry.fill',
		stylers: [{ visibility: 'on' }, { color: '#212121' }],
	},
	{
		featureType: 'landscape.natural',
		elementType: 'geometry.fill',
		stylers: [{ visibility: 'on' }, { color: '#212121' }],
	},
	{
		featureType: 'landscape.natural.landcover',
		elementType: 'geometry.fill',
		stylers: [{ color: '#212121' }, { visibility: 'on' }],
	},
	{
		featureType: 'landscape.natural.terrain',
		elementType: 'geometry.fill',
		stylers: [{ color: '#212121' }, { visibility: 'on' }],
	},
	{
		featureType: 'poi',
		elementType: 'geometry',
		stylers: [{ lightness: 21 }, { color: '#212121' }],
	},
	{ featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#181818' }] },
	{ featureType: 'road', elementType: 'geometry', stylers: [{ visibility: 'simplified' }] },
	{
		featureType: 'road.highway',
		elementType: 'geometry',
		stylers: [{ visibility: 'simplified' }, { color: '#3c3c3c' }],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.stroke',
		stylers: [{ lightness: 29 }, { weight: 0.2 }],
	},
	{
		featureType: 'road.highway.controlled_access',
		elementType: 'geometry',
		stylers: [{ color: '#4e4e4e' }, { visibility: 'simplified' }, { lightness: '-20' }],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry',
		stylers: [{ visibility: 'simplified' }, { color: '#373737' }],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry.fill',
		stylers: [{ visibility: 'on' }],
	},
	{
		featureType: 'road.local',
		elementType: 'geometry',
		stylers: [{ lightness: 16 }, { color: '#313131' }, { visibility: 'simplified' }],
	},
	{
		featureType: 'transit',
		elementType: 'geometry',
		stylers: [{ color: '#212121' }, { lightness: 19 }, { visibility: 'off' }],
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [{ color: '#000000' }, { visibility: 'on' }],
	},
];

const NEW_ZEALAND_BOUNDS = {
	north: -34.36,
	south: -47.35,
	west: 166.28,
	east: -175.81,
};

let scriptRequested = false;
let mapsReady = false;
const queue = [];

function initMap(el) {
	if (el.dataset.mapReady === '1' || typeof google === 'undefined' || !google.maps) {
		return;
	}
	const lat = parseFloat(el.dataset.lat);
	const lng = parseFloat(el.dataset.lng);
	if (Number.isNaN(lat) || Number.isNaN(lng)) {
		return;
	}
	el.dataset.mapReady = '1';
	const preset = el.dataset.googleMap;
	const wide = window.innerWidth > 1024;

	if (preset === 'contact') {
		const center = {
			lat: lat + (wide ? 0.002 : 0),
			lng: lng + (wide ? 0.004 : 0),
		};
		const map = new google.maps.Map(el, {
			center: center,
			zoom: 16,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			keyboardShortcuts: false,
			draggable: true,
			styles: contactStyles,
		});
		new google.maps.InfoWindow({
			content: '',
			disableAutoPan: false,
		});
		const marker = new google.maps.Marker({
			position: { lat: lat, lng: lng },
			icon: {
				url: '/dist/images/icons/marker.svg',
				anchor: new google.maps.Point(25, 44),
				scaledSize: new google.maps.Size(50, 44),
			},
			map: map,
		});
		marker.addListener('click', function () {
			return false;
		});
		return;
	}

	const map = new google.maps.Map(el, {
		center: { lat: lat, lng: lng },
		restriction: {
			latLngBounds: NEW_ZEALAND_BOUNDS,
			strictBounds: false,
		},
		zoom: 15,
		minZoom: 6,
		maxZoom: 18,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: true,
		fullscreenControl: false,
		styles: listingStyles,
	});
	const marker = new google.maps.Marker({
		position: { lat: lat, lng: lng },
		icon: {
			url: '/dist/images/icons/marker.svg',
			anchor: new google.maps.Point(14, 40),
			scaledSize: new google.maps.Size(28, 40),
		},
		map: map,
	});
	marker.addListener('click', function () {
		map.setZoom(15);
		map.setCenter({ lat: lat, lng: lng });
	});
}

function flushQueue() {
	mapsReady = true;
	const pending = queue.splice(0);
	pending.forEach(initMap);
}

function loadScript(apiKey) {
	if (scriptRequested || !apiKey) {
		return;
	}
	scriptRequested = true;
	window.initGlasshouseMaps = flushQueue;
	const script = document.createElement('script');
	script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&callback=initGlasshouseMaps&region=NZL';
	script.async = true;
	script.defer = true;
	document.body.appendChild(script);
}

function enqueue(el) {
	if (el.dataset.mapQueued === '1') {
		return;
	}
	el.dataset.mapQueued = '1';
	if (mapsReady) {
		initMap(el);
		return;
	}
	queue.push(el);
	loadScript(el.dataset.apiKey);
}

function observeMaps() {
	const nodes = document.querySelectorAll('[data-google-map]');
	if (!nodes.length) {
		return;
	}
	if (!('IntersectionObserver' in window)) {
		nodes.forEach(enqueue);
		return;
	}
	const observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) {
				return;
			}
			observer.unobserve(entry.target);
			enqueue(entry.target);
		});
	}, { rootMargin: ROOT_MARGIN });
	nodes.forEach(function (node) {
		observer.observe(node);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', observeMaps);
} else {
	observeMaps();
}
